import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import t from 'ember-intl/helpers/t';
import { VStack } from 'tio-ui/components/layout';
import Button from 'tio-ui/components/button';
import { PhPrinter } from 'ember-phosphor-icons';
import type { RecommendationExtension as RecommendationModel } from 'tio-data/data/resources/recommendation.ext';
import StrategyFinder0726PlanComparison from 'tio-employee/components/strategy-finder-0726/plan-comparison';
import StrategyFinder0726ResultsTable from 'tio-employee/components/strategy-finder-0726/results-table';
import StrategyFinder0726InputsSummary from 'tio-employee/components/strategy-finder-0726/inputs-summary';

interface S {
  Args: {
    model: RecommendationModel;
  };
}

export default class StrategyFinder0726ResultsTemplate extends Component<S> {
  @service declare router: RouterService;

  // Native browser print — the print CSS (.print-area / .print-hide in
  // styles/app.css) hides chrome and renders just the results + graphs as PDF.
  printPdf = () => {
    window.print();
  };

  goToDashboard = () => {
    this.router.transitionTo('authenticated.strategy-finder-0726.index');
  };

  <template>
    <VStack class="print-area">
      <StrategyFinder0726PlanComparison @recommendation={{@model}} />
      <StrategyFinder0726ResultsTable @recommendation={{@model}} />
      <StrategyFinder0726InputsSummary @recommendation={{@model}} />

      <div class="print-hide tio-row">
        <Button @intent="default" @appearance="outlined" {{on "click" this.printPdf}}>
          <PhPrinter class="mr-2" @size={{18}} />
          {{t "strategy_finder_0726.print_pdf"}}
        </Button>
        <Button @intent="default" @appearance="outlined" {{on "click" this.goToDashboard}}>
          {{t "strategy_finder_0726.go_to_dashboard"}}
        </Button>
      </div>
    </VStack>
  </template>
}
